import React from 'react';
import { useToast } from '../ToastContext';
import './Toast.css';

export default function Toast() {
  const { toasts } = useToast();
  if (!toasts.length) return null;
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>{t.message}</div>
      ))}
    </div>
  );
}
